import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { TextField, makeTextFieldAutoFocus } from 'shared/ui/TextField'
import { PresetContainer, PresetField, PresetFooter } from 'shared/Preset'

type IRenameClientModalProps = {
  name: string
  onClose: () => void
  onRename: (name: string) => Promise<void>
}

export const RenameClientModal = observer(
  ({ name, onClose, onRename }: IRenameClientModalProps) => {
    const [newName, setNewName] = useState(name)
    const [loading, setLoading] = useState(false)

    const handleSave = async () => {
      setLoading(true)
      await onRename(newName)
      setLoading(false)
    }

    return (
      <PresetContainer>
        <PresetField>
          <TextField
            InputProps={{
              placeholder: 'Enter client name',
            }}
            variant='stroke'
            size='medium'
            value={newName}
            onChange={setNewName}
            mainActions={[makeTextFieldAutoFocus({ withFocus: true })]}
          />
        </PresetField>
        <PresetFooter>
          <Button text='Cancel' size='medium' contained='secondary' onClick={onClose} />
          <Button
            text='Save'
            size='medium'
            disabled={!newName.length || newName === name || loading}
            onClick={handleSave}
          />
        </PresetFooter>
      </PresetContainer>
    )
  }
)
